import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

import { createAppQueryClient } from '@/core/query/query-client.js';

/** Un QueryClient por montaje: los tests quedan aislados entre sí. */
export function AppProviders({ children }: Readonly<{ readonly children: ReactNode }>) {
  const [queryClient] = useState(createAppQueryClient);
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
